/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Gu6Inputs */

const en__field_enum_tuda_gu6 = /** @type {(inputs: _Field_Enum_Tuda_Gu6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goethe-Universität Frankfurt`)
};

const de__field_enum_tuda_gu6 = /** @type {(inputs: _Field_Enum_Tuda_Gu6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goethe-Universität Frankfurt`)
};

/**
* | output |
* | --- |
* | "Goethe-Universität Frankfurt" |
*
* @param {_Field_Enum_Tuda_Gu6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_gu6 = /** @type {((inputs?: _Field_Enum_Tuda_Gu6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Gu6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_gu6(inputs)
	return de__field_enum_tuda_gu6(inputs)
});
export { _field_enum_tuda_gu6 as "_field_enum_TUDA_GU" }